var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('listarCliente',{attrs:{"titulo":'Cargar Carrito de Compra para'}}),_c('articuloEquivalente')],1)}
var staticRenderFns = []

export { render, staticRenderFns }